import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const suburbansQuery = gql`query suburbans{
  suburbans {
    id
    state_id
    metro_region_id
    name
    pincode
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class SuburbansService {

  constructor(private apollo: Apollo) { }

  getSuburbans(){
    return this.apollo.use('external').query({
      query: suburbansQuery
    }).pipe(pluck('data', 'suburbans'));
  }
}
